/**
 * Base: Slideshow element
 */


var ed = ed || {};

ed.slideshow = new function(){
    /**
     * Init function
     */
    this.init = function() {
        slideshow();
    };

    function slideshow() {
        // Remove display none class
        $('.slideshow-element').removeClass('js-hidden');

        // Trigger redraw for transition
        $('.slideshow-element').first().offsetHeight;

        // Init flickity
        $('.slideshow-element').flickity({
            cellSelector: '.slideshow-element__item',
            accessibility: false,
            pageDots: true,
            contain: true,
            cellAlign: 'center',
            arrowShape: {
                x0: 10,
                x1: 60, y1: 50,
                x2: 70, y2: 40,
                x3: 30
            }
        });
    }
};
